import { render, staticRenderFns } from "./change-coach-view.vue?vue&type=template&id=469dd068&lang=pug&"
import script from "./change-coach-view.vue?vue&type=script&lang=js&"
export * from "./change-coach-view.vue?vue&type=script&lang=js&"
import style0 from "./change-coach-view.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports